import * as yup from 'yup';
import { ChildCollectionEnum, DEFAULT_MAX_STRING_MSG, STRING_DEFAULT_MAX_LENGTH, VALIDATORS } from 'core';

export const CHILD_PROTECTION_VALIDATION_SCHEMA = yup.object().shape({
  allowedPeople: yup.array().when('childCollectionOption', {
    is: (childCollectionOption: number) => childCollectionOption === ChildCollectionEnum.ParentPickup,
    then: yup.array().of(
      yup.object().shape({
        familyName: yup
          .string()
          .required('Family Name is required')
          .max(STRING_DEFAULT_MAX_LENGTH, DEFAULT_MAX_STRING_MSG),
        otherNames: yup
          .string()
          .required('Other/given names are required')
          .max(STRING_DEFAULT_MAX_LENGTH, DEFAULT_MAX_STRING_MSG),
        telephone: VALIDATORS.telephone.required('Alternative contact number is required'),
      })
    ),
  }),
  childCollectionOption: yup.number().required('Please select one option'),
  childStatementConfirmed: yup.boolean().when('childCollectionOption', {
    is: (childCollectionOption: number) => childCollectionOption === ChildCollectionEnum.ParentPickup,
    then: yup.boolean().isTrue('Please confirm.'),
  }),
});
